import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getData } from '../redux/features/productSlice';
import { Link } from 'react-router-dom';
import { addItem } from '../redux/features/pageSlice';

const Products = () => {
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(state => state.products);

  useEffect(() => {
    dispatch(getData());
  }, [dispatch]);

  const handleAdd = (product) => {
    dispatch(addItem(product)); // Dispatch addItem action
  };

  return (
    <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4'>
      {loading && <p>Loading...</p>}
      {error && <p>Error...</p>}
      {data.map((product) => (
        <div key={product.id} className="bg-white shadow-lg rounded-lg p-4 hover:shadow-2xl">
          <Link to={`/${product.id}`}>
            <img src={product.image} alt={product.title} className="w-full h-40 object-contain rounded-lg" />
            <h2 className="text-lg font-semibold text-gray-800">{product.title}</h2>
            <p className="text-gray-600 mt-2">${product.price}</p>
          </Link>
          <button 
            onClick={() => handleAdd(product)} 
            className="mt-2 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 w-full"
          >
            Add to Bag
          </button>
        </div>
      ))}
    </div>
  );
};

export default Products;
